import { storableError } from '../../util/errors';

import {
  fetchPets,
  createPet,
  updatePet,
  deletePet,
  uploadPetFiles,
  // createPetImage,
  fetchPetImages,
  updatePetImage,
  deletePetImage,
} from '../../util/api';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ProfileManagePetsPage/CLEAR_UPDATED_FORM';

export const UPDATE_PET_REQUEST = 'app/ProfileManagePetsPage/UPDATE_PET_REQUEST';
export const UPDATE_PET_SUCCESS = 'app/ProfileManagePetsPage/UPDATE_PET_SUCCESS';
export const UPDATE_PET_ERROR = 'app/ProfileManagePetsPage/UPDATE_PET_ERROR';

export const CREATE_PET_REQUEST = 'app/ProfileManagePetsPage/CREATE_PET_REQUEST';
export const CREATE_PET_SUCCESS = 'app/ProfileManagePetsPage/CREATE_PET_SUCCESS';
export const CREATE_PET_ERROR = 'app/ProfileManagePetsPage/CREATE_PET_ERROR';

export const DELETE_PET_REQUEST = 'app/ProfileManagePetsPage/DELETE_PET_REQUEST';
export const DELETE_PET_SUCCESS = 'app/ProfileManagePetsPage/DELETE_PET_SUCCESS';
export const DELETE_PET_ERROR = 'app/ProfileManagePetsPage/DELETE_PET_ERROR';

export const FETCH_PETS_REQUEST = 'app/ProfileManagePetsPage/FETCH_PETS_REQUEST';
export const FETCH_PETS_SUCCESS = 'app/ProfileManagePetsPage/FETCH_PETS_SUCCESS';
export const FETCH_PETS_ERROR = 'app/ProfileManagePetsPage/FETCH_PETS_ERROR';

// File upload action types
export const UPLOAD_FILES_REQUEST = 'app/ProfileManagePetsPage/UPLOAD_FILES_REQUEST';
export const UPLOAD_FILES_SUCCESS = 'app/ProfileManagePetsPage/UPLOAD_FILES_SUCCESS';
export const UPLOAD_FILES_ERROR = 'app/ProfileManagePetsPage/UPLOAD_FILES_ERROR';

export const FETCH_PET_IMAGES_REQUEST = 'app/ProfileManagePetsPage/FETCH_PET_IMAGES_REQUEST';
export const FETCH_PET_IMAGES_SUCCESS = 'app/ProfileManagePetsPage/FETCH_PET_IMAGES_SUCCESS';
export const FETCH_PET_IMAGES_ERROR = 'app/ProfileManagePetsPage/FETCH_PET_IMAGES_ERROR';

export const UPDATE_PET_IMAGE_REQUEST = 'app/ProfileManagePetsPage/UPDATE_PET_IMAGE_REQUEST';
export const UPDATE_PET_IMAGE_SUCCESS = 'app/ProfileManagePetsPage/UPDATE_PET_IMAGE_SUCCESS';
export const UPDATE_PET_IMAGE_ERROR = 'app/ProfileManagePetsPage/UPDATE_PET_IMAGE_ERROR';

export const DELETE_PET_IMAGE_REQUEST = 'app/ProfileManagePetsPage/DELETE_PET_IMAGE_REQUEST';
export const DELETE_PET_IMAGE_SUCCESS = 'app/ProfileManagePetsPage/DELETE_PET_IMAGE_SUCCESS';
export const DELETE_PET_IMAGE_ERROR = 'app/ProfileManagePetsPage/DELETE_PET_IMAGE_ERROR';

// ================ Reducer ================ //

const initialState = {
  updatePetInProgress: false,
  updatePetError: null,
  createPetInProgress: false,
  createPetError: null,
  deletePetInProgress: false,
  deletePetError: null,
  petsData: null,
  petImagesData: null,
  fetchPetsInProgress: false,
  fetchPetsError: null,
  uploadedFiles: [],
  uploadInProgress: false,
  uploadError: null,
  fetchPetImagesInProgress: false,
  fetchPetImagesError: null,
  updatePetImageInProgress: false,
  updatePetImageError: null,
  deletePetImageInProgress: false,
  deletePetImageError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PET_REQUEST:
      return {
        ...state,
        updatePetInProgress: true,
        updatePetError: null,
      };
    case UPDATE_PET_SUCCESS:
      return {
        ...state,
        updatePetInProgress: false,
      };
    case UPDATE_PET_ERROR:
      return {
        ...state,
        updatePetInProgress: false,
        updatePetError: payload,
      };

    case CREATE_PET_REQUEST:
      return {
        ...state,
        createPetInProgress: true,
        createPetError: null,
      };
    case CREATE_PET_SUCCESS:
      return {
        ...state,
        petsData: payload,
        createPetInProgress: false,
      };
    case CREATE_PET_ERROR:
      return {
        ...state,
        createPetInProgress: false,
        createPetError: payload,
      };

    case DELETE_PET_REQUEST:
      return {
        ...state,
        deletePetInProgress: true,
        deletePetError: null,
      };
    case DELETE_PET_SUCCESS:
      return {
        ...state,
        petsData: payload,
        deletePetInProgress: false,
      };
    case DELETE_PET_ERROR:
      return {
        ...state,
        deletePetInProgress: false,
        deletePetError: payload,
      };

    case FETCH_PETS_REQUEST:
      return {
        ...state,
        fetchPetsInProgress: true,
        fetchPetsError: null,
      };
    case FETCH_PETS_SUCCESS:
      return {
        ...state,
        petsData: payload,
        fetchPetsInProgress: false,
      };
    case FETCH_PETS_ERROR:
      return {
        ...state,
        petsData: null,
        fetchPetsInProgress: false,
        fetchPetsError: payload,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updatePetError: null, uploadImageError: null };

    case UPLOAD_FILES_REQUEST:
      return { ...state, uploadInProgress: true, uploadError: null };
    case UPLOAD_FILES_SUCCESS:
      return { 
        ...state, 
        uploadInProgress: false, 
        uploadedFiles: [...state.uploadedFiles, ...payload.files] 
      };
    case UPLOAD_FILES_ERROR:
      return { ...state, uploadInProgress: false, uploadError: payload };

    case FETCH_PET_IMAGES_REQUEST:
      return {
        ...state,
        fetchPetImagesInProgress: true,
        fetchPetImagesError: null,
      };
    case FETCH_PET_IMAGES_SUCCESS:
      return {
        ...state,
        petImagesData: payload,
        fetchPetImagesInProgress: false,
      };
    case FETCH_PET_IMAGES_ERROR:
      return {
        ...state,
        petImagesData: null,
        fetchPetImagesInProgress: false,
        fetchPetImagesError: payload,
      };

    case UPDATE_PET_IMAGE_REQUEST:
      return {
        ...state,
        updatePetImageInProgress: true,
        updatePetImageError: null,
      };
    case UPDATE_PET_IMAGE_SUCCESS:
      return {
        ...state,
        updatePetImageInProgress: false,
      };
    case UPDATE_PET_IMAGE_ERROR:
      return {
        ...state,
        updatePetImageInProgress: false,
        updatePetImageError: payload,
      };

    case DELETE_PET_IMAGE_REQUEST:
      return {
        ...state,
        deletePetImageInProgress: true,
        deletePetImageError: null,
      };
    case DELETE_PET_IMAGE_SUCCESS:
      return {
        ...state,
        petsData: payload,
        deletePetImageInProgress: false,
      };
    case DELETE_PET_IMAGE_ERROR:
      return {
        ...state,
        deletePetImageInProgress: false,
        deletePetImageError: payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

export const fetchPetsRequest = params => ({
  type: FETCH_PETS_REQUEST,
  payload: { params },
});
export const fetchPetsSuccess = result => ({
  type: FETCH_PETS_SUCCESS,
  payload: result,
});
export const fetchPetsError = error => ({
  type: FETCH_PETS_ERROR,
  payload: error,
  error: true,
});

export const updatePetRequest = params => ({
  type: UPDATE_PET_REQUEST,
  payload: { params },
});
export const updatePetSuccess = result => ({
  type: UPDATE_PET_SUCCESS,
  payload: result,
});
export const updatePetError = error => ({
  type: UPDATE_PET_ERROR,
  payload: error,
  error: true,
});

export const createPetRequest = params => ({
  type: CREATE_PET_REQUEST,
  payload: { params },
});
export const createPetSuccess = result => ({
  type: CREATE_PET_SUCCESS,
  payload: result,
});
export const createPetError = error => ({
  type: CREATE_PET_ERROR,
  payload: error,
  error: true,
});

export const deletePetRequest = params => ({
  type: DELETE_PET_REQUEST,
  payload: { params },
});
export const deletePetSuccess = result => ({
  type: DELETE_PET_SUCCESS,
  payload: result,
});
export const deletePetError = error => ({
  type: DELETE_PET_ERROR,
  payload: error,
  error: true,
});

export const fetchPetImagesRequest = params => ({
  type: FETCH_PET_IMAGES_REQUEST,
  payload: { params },
});
export const fetchPetImagesSuccess = result => ({
  type: FETCH_PET_IMAGES_SUCCESS,
  payload: result,
});
export const fetchPetImagesError = error => ({
  type: FETCH_PET_IMAGES_ERROR,
  payload: error,
  error: true,
});

export const uploadFileRequest = params => ({
  type: UPLOAD_FILES_REQUEST,
  payload: { params },
});
export const uploadFileSuccess = result => ({
  type: UPLOAD_FILES_SUCCESS,
  payload: result,
});
export const uploadFileError = error => ({
  type: UPLOAD_FILES_ERROR,
  payload: error,
  error: true,
});

export const updatePetImageRequest = params => ({
  type: UPDATE_PET_IMAGE_REQUEST,
  payload: { params },
});
export const updatePetImageSuccess = result => ({
  type: UPDATE_PET_IMAGE_SUCCESS,
  payload: result,
});
export const updatePetImageError = error => ({
  type: UPDATE_PET_IMAGE_ERROR,
  payload: error,
  error: true,
});

export const deletePetImageRequest = params => ({
  type: DELETE_PET_IMAGE_REQUEST,
  payload: { params },
});
export const deletePetImageSuccess = result => ({
  type: DELETE_PET_IMAGE_SUCCESS,
  payload: result,
});
export const deletePetImageError = error => ({
  type: DELETE_PET_IMAGE_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

export const doUpdatePet = (petId, payload) => (dispatch, getState, sdk) => {
  dispatch(updatePetRequest());

  if (!petId) {
    const error = new Error("Pet ID not found");
    dispatch(updatePetError(error));
    return Promise.reject(error);
  }

  return updatePet(petId, payload)
    .then(response => {
      dispatch(updatePetSuccess(response));
    })
    .catch(e => {
      dispatch(updatePetError(storableError(e)));
      throw e;
    });
};

export const doCreatePet = actionPayload => (dispatch, getState, sdk) => {
  dispatch(createPetRequest());

  return createPet(actionPayload)
    .then(response => {
      dispatch(createPetSuccess(response));
    })
    .catch(e => {
      dispatch(createPetError(storableError(e)));
      throw e;
    });
};

export const doDeletePet = petId => (dispatch, getState, sdk) => {
  dispatch(deletePetRequest());

  return deletePet(petId)
    .then(response => {
      dispatch(deletePetSuccess(response));
    })
    .catch(e => {
      dispatch(deletePetError(storableError(e)));
      throw e;
    });
};

// File upload thunk
export const uploadFiles = (files, petId = null, isPrimary = false) => dispatch => {
  dispatch(uploadFileRequest());
  return uploadPetFiles(files, petId, isPrimary)
    .then(data => {
      dispatch(uploadFileSuccess(data));
      return data.files; // Return the files array instead of the entire response
    })
    .catch(e => {
      dispatch(uploadFileError(storableError(e)));
      throw e;
    });
};

export const doFetchPetImages = (petId) => (dispatch, getState) => {
  dispatch(fetchPetImagesRequest());

  return fetchPetImages(petId)
    .then(response => {
      dispatch(fetchPetImagesSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchPetImagesError(storableError(e)));
      throw e;
    });

};

export const doUpdatePetImage = (petId, petImageId, payload) => (dispatch, getState, sdk) => {
  dispatch(updatePetImageRequest());

  if (!petImageId) {
    const error = new Error("Pet Image ID not found");
    dispatch(updatePetImageError(error));
    return Promise.reject(error);
  }

  return updatePetImage(petId, petImageId, payload)
    .then(response => {
      dispatch(updatePetImageSuccess(response));
    })
    .catch(e => {
      dispatch(updatePetImageError(storableError(e)));
      throw e;
    });
};

export const doDeletePetImage = (petId, id) => (dispatch, getState, sdk) => {
  dispatch(deletePetImageRequest());

  return deletePetImage(petId, id)
    .then(response => {
      dispatch(deletePetImageSuccess(response));
    })
    .catch(e => {
      dispatch(deletePetImageError(storableError(e)));
      throw e;
    });
};

export const doFetchPets = () => (dispatch, getState) => {
  dispatch(fetchPetsRequest());

  return fetchPets()
    .then(response => {
      dispatch(fetchPetsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchPetsError(storableError(e)));
      throw e;
    });

};

export const loadData = () => (dispatch, getState) => {
  dispatch(fetchPetsRequest());

  return fetchPets()
    .then(response => {
      dispatch(fetchPetsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchPetsError(storableError(e)));
      throw e;
    });

};
